import { Injectable } from '@angular/core';
import {FormbirdInjectorService} from '../injector/formbird-injector.service';

@Injectable({
  providedIn: 'root'
})
export class ModifiedFieldService {
  ajsService: any;

  constructor(private injector: FormbirdInjectorService) {
    this.ajsService = injector.get('ModifiedFieldService');
  }

  /**
   * Reset the current form to its un-interacted state.
   */
  resetFormDirty() {
    this.ajsService.resetFormDirty();
  }

  /**
   * Check if the current form is dirty, that make the save button appear and blink or display unsaved changes dialog
   */
  isDirty() {
    return this.ajsService.isDirty();
  }

  /*
   * This method is used to add modified field by document id.
   * Before adding should check whether the version of the document has changed from the original because
   * there is a case reset current document from the one returned from server once it is saved.
   * @returns: true if adding successfully, otherwise: false
   */
  addModifiedField(documentId, changedFieldName, documentListId, shouldCompareDocuments?, overrideTemplateId?) {
    return this.ajsService.addModifiedField(documentId,
      changedFieldName,
      documentListId,
      shouldCompareDocuments,
      overrideTemplateId);
  }
}
